module.exports = __webpack_public_path__ + "static/media/shape_Z.c57fbb36.glb";